import FONTS from '../../../style/fonts';
import TEAM_THEMES from '../../../style/team.color';
import COLORS from '../../../style/universal.color';

const fonts = {
    family: {
        primary: FONTS.primaryFont
    },
};

const defaultTheme = {
    fonts,
    teamThemes: TEAM_THEMES,
    primaryTextColor: COLORS.mlbBlack,
    primaryLinkColor: COLORS.linkBlue,
    primaryLinkHoverColor: COLORS.linkBlueOnDark,
    disabledLinkColor: COLORS.mlbGrey6,
};

export default defaultTheme;
